'use strict';

import slicks from './../common/slicks';
import enquiryValues from './enquiryValues';

export default function enquirySlider() {
    let $enquirySlider = $('.js-enquiry-slider');

    if (!$enquirySlider.length) {
        return;
    }

    slicks($enquirySlider, {
        arrows: false,
        autoplay: true,
        slidesToShow: 5,
        speed: 3000,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        }]
    });

    $('#enquiry').on('shown.bs.modal', () => {
        // Sometimes return false destroying chain
        $enquirySlider
            .slick('removeSlide', null, null, true);

        $enquirySlider
            .slick('slickAdd', $('.js-comparison-object')
                .clone()
                .addClass('js-enquiry-object')
                .find('.rmb-object-img-hld')
                    .addClass('rmb-object-img-hld-to-delete')
                .end()
            )
            .find('[data-bg], [data-src]')
                .lazyLoadXT()
            .end()
            .slick('getSlick').refresh();

        $(window).trigger('resize');

        enquiryValues().update();
    });

    $(document).on('click', '.js-enquiry-object', function () {
        $enquirySlider
            .slick('slickRemove', parseInt($(this).attr('data-slick-index')))
            .slick('getSlick').refresh();

        enquiryValues().update();
    });
}
